import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCog, faLink } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import useSystem from '@hooks/useSystem'

type SystemToolsProps = {
  systemPayload: ReturnType<typeof useSystem>,
}

const SystemTools = (props: SystemToolsProps) => {
  const { systemPayload } = props
  const {
    callbacks: {
      manageSlackWebhookSettings,
      manageSystemIntegrations,
      manageSystemMaintenance,
    },
  } = systemPayload || {}

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faLink} />}
        // @ts-expect-error TS2322
        marginBottom="medium"
        onClick={() => manageSlackWebhookSettings()}
        size="medium"
      >
        Slack / Teams Webhooks Settings
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCog} />}
        onClick={() => manageSystemIntegrations()}
        size="medium"
      >
        Integrations
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faCog} />}
        onClick={() => manageSystemMaintenance()}
        // @ts-expect-error TS2322
        marginTop="medium"
        size="medium"
      >
        Maintenance
      </Button>
    </Tools>
  )
}

export default SystemTools
